import { CacheProvider } from "@emotion/react";

import React from "react";

import { createRoot } from "react-dom/client";

import { ThemeProvider } from "@mui/material/styles";

import App from "./App";
import AlertContextProvider from "./context/alert/AlertContextProvider";
import AuthProvider from "./context/Auth/AuthProvider";
import DashboardProvider from "./context/dashoard/DashboardProvider";
import DropzoneState from "./context/dropzone/DropzoneState";
import { FeatureTogglesProvider } from "./context/FeatureToggles/FeatureTogglesProvider";
import LanguageProvider from "./context/language/LanguageProvider";
import TimeZoneProvider from "./context/TimeZone/TimeZoneProvider";
import emotionCache from "./emotionCache";

import "./i18next/config";
import "./index.css";

import { muiThemeOverride as theme } from "./shared";

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <CacheProvider value={emotionCache}>
      <ThemeProvider theme={theme}>
        <AlertContextProvider>
          <TimeZoneProvider>
            <FeatureTogglesProvider>
              <AuthProvider>
                <LanguageProvider>
                  <DropzoneState>
                    <DashboardProvider>
                      <App />
                    </DashboardProvider>
                  </DropzoneState>
                </LanguageProvider>
              </AuthProvider>
            </FeatureTogglesProvider>
          </TimeZoneProvider>
        </AlertContextProvider>
      </ThemeProvider>
    </CacheProvider>
  </React.StrictMode>
);
